
  import { defineComponent } from 'vue';
  import './content-block.scss';

  /**
   * Content molecule is used to wrap around content blocks such as groups of paragraphs, headings, etc.
   * The content molecule applies necessary styling for some of the atoms that get based through, as well as addressing padding between each component.
   * 
   * @example
   * <code>import TpxContentBlock from '@manifesto-tech/tpximpact-design-system/components/molecules/content/content-block.vue'</code>
   */
  export default defineComponent({
    name: 'TpxContentBlock',
  });
